var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 31 31"
  }, props), /*#__PURE__*/React.createElement("foreignObject", {
    width: 65.526,
    height: 65.526,
    x: -17.263,
    y: -17.263
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      clipPath: "url(#arrow_svg__a)",
      height: "100%",
      width: "100%"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    fill: "url(#arrow_svg__b)",
    "data-figma-bg-blur-radius": 17.263
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1967DE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.969 15.5H11.03M14.688 11.844 11.03 15.5l3.656 3.656"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "arrow_svg__b",
    x1: 15.5,
    x2: 15.5,
    y1: 0,
    y2: 49.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "arrow_svg__a",
    transform: "translate(17.263 17.263)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5
  })))));
};
export default SvgArrow;